import * as React from 'react';
import { BodyLargeRegular, H1Emphasized, View, XStack } from 'smoothie';

import { CardColor, CardForm } from '../../types/Card';
import { DummyFruitfulCard } from '../cards/FruitfulCard';
import { CashbackCard } from './FloatingCard';

const CashBackSection = ({
    cashBackRate,
    cashBackPolicyUnrestricted,
}: {
    cashBackRate: string;
    cashBackPolicyUnrestricted: boolean;
}) => (
    <View
        position="relative"
        minHeight={140}
        marginTop={-24}
        $sm={{ minHeight: 210, marginTop: -8 }}
    >
        <XStack
            width="70%"
            paddingLeft={4}
            flexWrap="wrap"
            alignItems="baseline"
            $platform-web={{ gap: 4, width: '70%' }}
        >
            <BodyLargeRegular
                color="$wasabi1200"
                $sm={{ fontSize: 30, lineHeight: 40 }}
            >
                {cashBackPolicyUnrestricted ? 'Earn ' : 'Up to'}
            </BodyLargeRegular>
            <H1Emphasized
                color="$wasabi1200"
                $sm={{ fontSize: 54, lineHeight: 56 }}
                lineHeight={45}
            >
                {' '}
                {cashBackRate}
            </H1Emphasized>
            <BodyLargeRegular
                color="$wasabi1200"
                fontSize="$5"
                $sm={{ fontSize: 30, lineHeight: 40 }}
            >
                cash back² on spend{'\n'}when you add a card
            </BodyLargeRegular>
        </XStack>
        <View
            position="absolute"
            right={-20}
            top={20}
            width={200}
            height={120}
            $mobile_mini={{ scale: 0.8 }}
            $sm={{ scale: 1.3 }}
        >
            <View
                position="absolute"
                right={0}
                bottom={20}
                style={{
                    transform: [{ rotate: '4deg' }, { scale: 0.6 }],
                }}
            >
                <DummyFruitfulCard
                    form={CardForm.VIRTUAL}
                    color={CardColor.GREEN}
                />
            </View>
            <View
                position="absolute"
                left={20}
                bottom={40}
                style={{
                    transform: [{ rotate: '4deg' }, { scale: 0.6 }],
                }}
            >
                <DummyFruitfulCard
                    form={CardForm.PHYSICAL}
                    showFormLabel={false}
                />
            </View>
            <View
                position="absolute"
                right="65%"
                bottom="90%"
                style={{
                    transform: [{ rotate: '-4deg' }, { scale: 0.65 }],
                }}
            >
                <CashbackCard />
            </View>
        </View>
    </View>
);

export default CashBackSection;
